import mixpanel from "mixpanel-browser";

import { alert } from "../components/common/Alert.js";
import { getTempScribenoteFlask } from "../utils";

export async function getCouponInfo(promotionalCode) {
  if (!promotionalCode) {
    return null;
  }

  const SCRIBENOTE_FLASK = getTempScribenoteFlask();

  const couponResponse = await fetch(
    `${SCRIBENOTE_FLASK}/validate-coupon`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        promotionalCode,
      }),
      credentials: "include",
    },
  );

  const couponJson = await couponResponse.json();
  return couponJson;
}

const SCRIBENOTE_FLASK = getTempScribenoteFlask();

export async function instantiateOrgPortal() {
  fetch(`${SCRIBENOTE_FLASK}/create-org-portal-session`, {
    method: "post",
    headers: {
      "Content-type": "application/json",
    },
    credentials: "include",
  })
    .then((response) => response.json())
    .then((data) => {
      const redirectUrl = data.redirect;
      window.location.href = redirectUrl;
    })
    .catch((error) => {
      alert("error", error.message);
    });
}

export async function instantiateCustomerPortal() {
  fetch(`${SCRIBENOTE_FLASK}/create-customer-portal-session`, {
    method: "post",
    headers: {
      "Content-type": "application/json",
    },
    credentials: "include",
  })
    .then((response) => response.json())
    .then((data) => {
      const redirectUrl = data.redirect;
      window.location.href = redirectUrl;
    })
    .catch((error) => {
      alert("error", error.message);
    });
}

export function handleSetup(returnUrl) {
  fetch(`${SCRIBENOTE_FLASK}/create-setup-session`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      returnUrl: returnUrl,
    }),
    credentials: "include",
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.error) {
        console.error(data.error);
        mixpanel.track("Billing Setup Failed", {
          error: data.error,
        });
        alert("error", data.error);
      } else {
        window.location = data.sessionUrl;
      }
    })
    .catch((err) => {
      console.error(err);
    });
}

export function handleSubscribe({ priceId, route = "/account" }) {
  fetch(`${SCRIBENOTE_FLASK}/create-checkout-session`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      priceId,
      returnUrl: `${window.location.origin}${route}`,
    }),
    credentials: "include",
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.error) {
        console.error(data.error);
        mixpanel.track("Upgrade Plan Failed", {
          error: data.error,
        });
        alert("error", data.error);
      } else {
        window.location = data.sessionUrl;
      }
    })
    .catch((err) => {
      console.error(err);
    });
}

export const previewSubscription = async (
  priceId,
  customerDetails,
) => {
  const response = await fetch(
    `${SCRIBENOTE_FLASK}/preview-subscription`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify({
        priceId,
        customerId: customerDetails?.customerId,
        ipAddress: customerDetails?.ipAddress,
        address: customerDetails?.address,
      }),
    },
  );

  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.error);
  }
  return data;
};
